import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Document360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/knowledge/docs").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Document360" title="Controlled Document Management" description="Numbering, templates, review, approval, distribution, expiry, watermarking, retention and legal hold — with digital signatures and OCR." />
            <KpiGrid kpis={data?.kpis || []} accent="cobalt" cols={4} />
            <Panel title="Master Document List" accent="cobalt">
                <DataTable
                    columns={[
                        { key: "doc_no", label: "Doc #" },
                        { key: "title", label: "Title" },
                        { key: "type", label: "Type" },
                        { key: "revision", label: "Rev" },
                        { key: "issued", label: "Issued", render: (r) => r.issued.slice(0, 10) },
                        { key: "next_review", label: "Next Review", render: (r) => r.next_review.slice(0, 10) },
                        { key: "classification", label: "Class" },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                    ]}
                    rows={data?.documents || []}
                    testid="doc-table"
                />
            </Panel>
        </div>
    );
}
